import useAnalyticsContext from '@client/hooks/useAnalyticsContext';
import AnalyticsConstants from '@constants/analytics';
import { useCallback } from 'react';
import { PRICING_DETAILS_PRODUCT_AREA } from './trackingConstants';

export const useTrackEstimateDisplayed = () => {
	const { track } = useAnalyticsContext();

	return useCallback(
		(estimateOutput: Record<string, string>) => {
			track({
				event: AnalyticsConstants.STOREFRONT_INTERACTION,
				properties: {
					selection: PRICING_DETAILS_PRODUCT_AREA,
					action: 'Display pricing estimate',
					estimate_output: estimateOutput,
				},
			});
		},
		[track],
	);
};
